import { del, get, patch, post } from './requests'

export const getServiceOrdersCountWidgets = key => params =>
  get(['widgets', 'service-orders-quantity'], { key, transformPayload: true, params })

export const getWidgetsOptions = key => () =>
  get(['/new-widgets/'], { key, transformPayload: true })

export const getWidgetResults =
  key =>
  ({ optionId, params }) =>
    get(['/new-widgets', optionId], { key, transformPayload: true, params })

export const getWidgetsList = key => params =>
  get(['new-widgets', 'list'], { key, transformPayload: true, params })

export const createWidget = key => payload =>
  post(['new-widgets'], { key, transformPayload: true }, payload)

export const getWidgetDetails = key => widgetId =>
  get(['new-widgets', widgetId, 'details'], { key, transformPayload: true })

export const updateWidget = key => (widgetId, payload) =>
  patch(['new-widgets', widgetId], { key, transformPayload: true }, payload)

export const deleteWidget = key => widgetId =>
  del(['new-widgets', widgetId], { key, transformPayload: true })
